import React, { useState } from "react";
import {
    Box,
    Card,
    Tabs,
    Tab,
} from "@mui/material";
import { PostsStatsTab } from "./PostsStatsTab";
import { AprendaStatsTab } from "./AprendaStatsTab";
import { DesafiosStatsTab } from "./DesafiosStatsTab";

const TabPanel = ({ children, value, index, ...other }) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`stats-tabpanel-${index}`}
            aria-labelledby={`stats-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
};

const a11yProps = (index) => {
    return {
        id: `stats-tab-${index}`,
        'aria-controls': `stats-tabpanel-${index}`,
    };
};

export const StatsReport = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Box>
            <Card sx={{ mb: 3 }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="fullWidth"
                        sx={{
                            "& .MuiTab-root": {
                                color: "rgba(0, 0, 0, 0.87)",
                                fontSize: { xs: "0.875rem", sm: "1rem" },
                                padding: { xs: "6px 12px", sm: "12px 16px" },
                                "&.Mui-selected": {
                                    color: "var(--primary-color)",
                                },
                            },
                            "& .MuiTabs-indicator": {
                                backgroundColor: "var(--primary-color)",
                            },
                        }}
                    >
                        <Tab label="Posts da Comunidade" {...a11yProps(0)} />
                        <Tab label="Trilha de Aprenda" {...a11yProps(1)} />
                        <Tab label="Desafios" {...a11yProps(2)} />
                    </Tabs>
                </Box>
            </Card>

            <TabPanel value={tabValue} index={0}>
                <PostsStatsTab />
            </TabPanel>
            
            <TabPanel value={tabValue} index={1}>
                <AprendaStatsTab />
            </TabPanel>

            <TabPanel value={tabValue} index={2}>
                <DesafiosStatsTab />
            </TabPanel>
        </Box>
    );
};
